import _defineProperty from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { useRef as e } from "react";
import { useInput as t, SyntheticChangeError as r } from "@react-input/core";
function n(e, _ref) {
  var t = _ref.replacementChars,
    r = _ref.replacement,
    n = _ref.separate;
  var a = t,
    l = "";
  var _iterator = _createForOfIteratorHelper(e),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r$a$;
      var _t = _step.value;
      var _e = !Object.prototype.hasOwnProperty.call(r, _t) && ((_r$a$ = r[a[0]]) === null || _r$a$ === void 0 ? void 0 : _r$a$.test(_t));
      (n && _t === a[0] || _e) && (a = a.slice(1), l += _t);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return l;
}
function a(e, t, r) {
  var n = ["[", "]", "\\", "/", "^", "$", ".", "|", "?", "*", "+", "(", ")", "{", "}"];
  var a = "";
  for (var _l = 0; _l < e.length; _l++) {
    var _p = Object.prototype.hasOwnProperty.call(t, e[_l]),
      _s = r ? "(?!".concat(e[_l], ")") : "";
    0 === _l && (a += "^"), a += _p ? _s + t[e[_l]].toString().slice(1, -1) : n.includes(e[_l]) ? "\\".concat(e[_l]) : e[_l], _l === e.length - 1 && (a += "$");
  }
  return a;
}
function l(e, _ref2) {
  var t = _ref2.mask,
    r = _ref2.replacement,
    n = _ref2.showMask;
  var l = function (e, _ref3) {
    var t = _ref3.mask,
      r = _ref3.replacement;
    var n = 0,
      a = "";
    var _iterator2 = _createForOfIteratorHelper(t),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _l2 = _step2.value;
        Object.prototype.hasOwnProperty.call(r, _l2) && void 0 !== e[n] ? a += e[n++] : a += _l2;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return a;
  }(e, {
    mask: t,
    replacement: r
  });
  var p = function (e, _ref4) {
    var t = _ref4.mask,
      r = _ref4.replacement;
    return e.split("").map(function (e, n) {
      return {
        type: Object.prototype.hasOwnProperty.call(r, e) ? "replacement" : e === t[n] ? "mask" : "input",
        value: e,
        index: n
      };
    });
  }(l, {
    mask: t,
    replacement: r
  });
  if (!n) {
    var _e2 = -1;
    for (var _t2 = p.length - 1; _t2 >= 0; _t2--) if ("input" === p[_t2].type) {
      _e2 = p[_t2].index;
      break;
    }
    l = l.slice(0, _e2 + 1);
  }
  var s = a(t, r, !1),
    c = a(t, r, !0);
  return {
    value: l,
    input: e,
    parts: p,
    pattern: s,
    isValid: RegExp(c).test(l)
  };
}
function p(e, _ref5) {
  var _ref5$start = _ref5.start,
    t = _ref5$start === void 0 ? 0 : _ref5$start,
    r = _ref5.end,
    n = _ref5.mask,
    a = _ref5.replacement,
    l = _ref5.separate;
  var p = e.slice(t, r),
    s = n.slice(t, r);
  var c = "";
  for (var _e3 = 0; _e3 < s.length; _e3++) {
    var _t3 = Object.prototype.hasOwnProperty.call(a, s[_e3]);
    _t3 && void 0 !== p[_e3] && p[_e3] !== s[_e3] ? c += p[_e3] : _t3 && l && (c += s[_e3]);
  }
  return c;
}
var s = function s(e) {
  return function () {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    return new e("".concat(t.join("\n\n"), "\n"));
  };
};
var c = function c(e) {
  return e.length > 0 ? _defineProperty({}, e, /./) : {};
};
function o() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$mask = _ref7.mask,
    a = _ref7$mask === void 0 ? "" : _ref7$mask,
    _ref7$replacement = _ref7.replacement,
    o = _ref7$replacement === void 0 ? {} : _ref7$replacement,
    _ref7$showMask = _ref7.showMask,
    i = _ref7$showMask === void 0 ? !1 : _ref7$showMask,
    _ref7$separate = _ref7.separate,
    u = _ref7$separate === void 0 ? !1 : _ref7$separate,
    h = _ref7.modify,
    m = _ref7.onMask;
  var d = "string" == typeof o ? c(o) : o,
    f = e(null);
  return t({
    init: function init(_ref8) {
      var e = _ref8.controlled,
        t = _ref8.initialValue;
      "production" !== process.env.NODE_ENV && function (_ref9) {
        var e = _ref9.initialValue,
          t = _ref9.mask,
          r = _ref9.replacement;
        e.length > t.length && console.error(s(Error)("The initialized value of the `value` or `defaultValue` property is longer than the value specified in the `mask` property. Check the correctness of the initialized value in the specified property.", "Invalid value: \"".concat(e, "\".")));
        var n = Object.keys(r).filter(function (e) {
          return e.length > 1;
        });
        n.length > 0 && console.error(s(Error)("Object keys in the `replacement` property are longer than one character. Replacement keys must be one character long. Check the correctness of the value in the specified property.", "Invalid keys: ".concat(n.join(", "), ".")));
        var a = t.slice(0, e.length);
        var l = -1;
        for (var _t4 = 0; _t4 < a.length; _t4++) {
          var _n = Object.prototype.hasOwnProperty.call(r, a[_t4]);
          if (!(a[_t4] === e[_t4] || _n && r[a[_t4]].test(e[_t4]))) {
            l = _t4;
            break;
          }
        }
        -1 !== l && console.error(s(Error)("An invalid character was found in the initialized property value `value` or `defaultValue` (index: ".concat(l, "). Check the correctness of the initialized value in the specified property."), "Invalid value: \"".concat(e, "\".")));
      }({
        initialValue: t,
        mask: a,
        replacement: d
      }), t = e || t ? t : i ? a : "";
      var r = {
        mask: a,
        replacement: d,
        showMask: i,
        separate: u
      };
      return f.current = {
        value: t,
        props: r,
        fallbackProps: r
      }, {
        value: t
      };
    },
    tracking: function tracking(_ref10) {
      var _h;
      var e = _ref10.inputType,
        t = _ref10.previousValue,
        s = _ref10.addedValue,
        o = _ref10.changeStart,
        m = _ref10.changeEnd;
      if (null === f.current) throw new r("The state has not been initialized.");
      f.current.value !== t ? f.current.props = f.current.fallbackProps : f.current.fallbackProps = f.current.props;
      var k = p(t, {
        end: o,
        mask: f.current.props.mask,
        replacement: f.current.props.replacement,
        separate: f.current.props.separate
      });
      var v = RegExp("[^".concat(Object.keys(f.current.props.replacement).join(""), "]"), "g"),
        y = f.current.props.mask.replace(v, "");
      if (k && (k = n(k, {
        replacementChars: y,
        replacement: f.current.props.replacement,
        separate: f.current.props.separate
      })), s && (s = n(s, {
        replacementChars: y.slice(k.length),
        replacement: f.current.props.replacement,
        separate: !1
      })), "insert" === e && "" === s) throw new r("The character does not match the key value of the `replacement` object.");
      var g = p(t, {
        start: m,
        mask: f.current.props.mask,
        replacement: f.current.props.replacement,
        separate: f.current.props.separate
      });
      if (f.current.props.separate) {
        var _e4 = f.current.props.mask.slice(o, m).replace(v, ""),
          _t5 = _e4.length - s.length;
        _t5 < 0 ? g = g.slice(-_t5) : _t5 > 0 && (g = _e4.slice(-_t5) + g);
      }
      g && (g = n(g, {
        replacementChars: y.slice(k.length + s.length),
        replacement: f.current.props.replacement,
        separate: f.current.props.separate
      }));
      var w = k + s + g;
      var _ref11 = (_h = h === null || h === void 0 ? void 0 : h(w)) !== null && _h !== void 0 ? _h : {},
        _ref11$mask = _ref11.mask,
        b = _ref11$mask === void 0 ? a : _ref11$mask,
        _ref11$replacement = _ref11.replacement,
        O = _ref11$replacement === void 0 ? d : _ref11$replacement,
        _ref11$showMask = _ref11.showMask,
        j = _ref11$showMask === void 0 ? i : _ref11$showMask,
        _ref11$separate = _ref11.separate,
        V = _ref11$separate === void 0 ? u : _ref11$separate;
      "string" == typeof O && (O = c(O));
      var E = l(w, {
          mask: b,
          replacement: O,
          showMask: j
        }),
        x = function (_ref12, _s2, _s3, _s4) {
          var e = _ref12.inputType,
            t = _ref12.value,
            r = _ref12.addedValue,
            n = _ref12.beforeChangeValue,
            a = _ref12.parts,
            l = _ref12.replacement,
            p = _ref12.separate;
          var s = a.filter(function (_ref13) {
              var e = _ref13.type;
              return "input" === e || p && "replacement" === e;
            }),
            c = (_s2 = s[n.length + r.length - 1]) === null || _s2 === void 0 ? void 0 : _s2.index,
            o = (_s3 = s[n.length - 1]) === null || _s3 === void 0 ? void 0 : _s3.index,
            i = (_s4 = s[n.length + r.length]) === null || _s4 === void 0 ? void 0 : _s4.index;
          if ("insert" === e) {
            if (void 0 !== c) return c + 1;
            if (void 0 !== i) return i;
            if (void 0 !== o) return o + 1;
          }
          if ("deleteForward" === e) {
            if (void 0 !== i) return i;
            if (void 0 !== o) return o + 1;
          }
          if ("deleteBackward" === e) {
            if (void 0 !== o) return o + 1;
            if (void 0 !== i) return i;
          }
          var u = t.split("").findIndex(function (e) {
            return Object.prototype.hasOwnProperty.call(l, e);
          });
          return -1 !== u ? u : t.length;
        }({
          inputType: e,
          value: E.value,
          addedValue: s,
          beforeChangeValue: k,
          parts: E.parts,
          replacement: O,
          separate: V
        });
      return f.current.value = E.value, f.current.props = {
        mask: b,
        replacement: O,
        showMask: j,
        separate: V
      }, {
        value: E.value,
        selectionStart: x,
        selectionEnd: x,
        __detail: E
      };
    },
    customInputEventType: "input-mask",
    customInputEventHandler: m
  });
}
export { o as default };